import React, {
  useState,
  useEffect
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import Editor from "../../../components/admin/Editor";

import "./AddProduct.css";
import { BACKEND_URL } from "../../../config";

function EditProduct() {

  const navigate = useNavigate();

  const { id } = useParams();

  const [categories, setCategories] =
    useState([]);

  const [saving, setSaving] =
    useState(false);

  const [imagePreview, setImagePreview] =
    useState(null);

  const [file, setFile] =
    useState(null);

  const [keywordInput, setKeywordInput] =
    useState("");

  const [keywordList, setKeywordList] =
    useState([]);

  const [formData, setFormData] =
    useState({

      productName: "",
      slug: "",
      sku: "",
      date: "",

      category_id: "",
      section: "",
      shortDescription: "",
      description: "",

      metaTitle: "",
      metaDescription: "",

      manufacturer: "",
      composition: "",

      shipTime: "",

      status: "Active",

      keywords: "",
    });

  const [faq, setFaq] =
    useState([]);

  const [packPricing, setPackPricing] =
    useState([]);

  // ================= FETCH PRODUCT =================

  useEffect(() => {

    fetch(
      `${BACKEND_URL}/api.php?module=product`
    )
      .then((res) => res.json())
      .then((data) => {

        if (data.success) {

          const product =
            data.data.find(
              (p) =>
                String(p.id) === String(id)
            );

          if (product) {

            setFormData(product);

            setFaq(
              typeof product.faq === "string"
                ? JSON.parse(product.faq)
                : product.faq || []
            );

            setPackPricing(
              typeof product.packPricing ===
                "string"
                ? JSON.parse(
                    product.packPricing
                  )
                : product.packPricing || []
            );

            setKeywordList(
              product.keywords
                ? product.keywords
                    .split(",")
                    .map((k) => k.trim())
                : []
            );

            if (product.image) {

              setImagePreview(
                `${BACKEND_URL}/${product.image}`
              );

            }

          }

        }

      });

  }, [id]);

  // ================= AUTO SLUG =================

  useEffect(() => {

    const generatedSlug =
      formData.productName
        ?.toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-");

    setFormData((prev) => ({
      ...prev,
      slug: generatedSlug,
    }));

  }, [formData.productName]);

  // ================= FETCH CATEGORY =================

  useEffect(() => {

    fetch(
      `${BACKEND_URL}/api.php?module=category`
    )
      .then((res) => res.json())
      .then((data) => {

        if (data.success) {

          setCategories(data.data);

        }

      });

  }, []);

  // ================= CHANGE =================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

  };

 // ================= PACK HANDLER =================

  const handlePackChange = (index, field, value) => {

    setPackPricing((prev) => {

      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      const size = parseFloat(updated[index].packSize);
      const price = parseFloat(updated[index].price);

      updated[index].unitPerPrice =
        size && price
          ? (price / size).toFixed(2)
          : "";

      return updated;
    });
  };

  const addPackRow = () => {

    setPackPricing([
      ...packPricing,
      {
        packSize: "",
        unit: "",
        price: "",
        unitPerPrice: "",
      },
    ]);
  };

  const removePackRow = (index) => {

    setPackPricing(
      packPricing.filter((_, i) => i !== index)
    );
  };

  // ================= KEYWORDS =================

  const handleKeywordKeyDown = (e) => {

    if (
      e.key === "Enter" ||
      e.key === ","
    ) {

      e.preventDefault();

      const value =
        keywordInput.trim();

      if (
        value &&
        !keywordList.includes(value)
      ) {

        const updated = [
          ...keywordList,
          value,
        ];

        setKeywordList(updated);

        setFormData({
          ...formData,
          keywords: updated.join(","),
        });

      }

      setKeywordInput("");

    }

  };

  const removeKeyword = (index) => {

    const updated =
      keywordList.filter(
        (_, i) => i !== index
      );

    setKeywordList(updated);

    setFormData({
      ...formData,
      keywords: updated.join(","),
    });

  };

  // ================= UPDATE =================

  const handleUpdate = async (e) => {

    e.preventDefault();

    setSaving(true);

    try {

      const form = new FormData();

      form.append("id", formData.id);

      form.append(
        "productName",
        formData.productName
      );

      form.append("slug", formData.slug);

      form.append("sku", formData.sku);

      form.append("date", formData.date);

      form.append(
        "category_id",
        formData.category_id
      );

      form.append(
        "section",
        formData.section
      );

      form.append(
        "shortDescription",
        formData.shortDescription
      );

      form.append(
        "description",
        formData.description
      );

      form.append(
        "metaTitle",
        formData.metaTitle
      );

      form.append(
        "metaDescription",
        formData.metaDescription
      );

      form.append(
        "manufacturer",
        formData.manufacturer
      );

      form.append(
        "composition",
        formData.composition
      );

      form.append(
        "shipTime",
        formData.shipTime
      );

      form.append(
        "status",
        formData.status
      );

      form.append(
        "keywords",
        formData.keywords
      );

      form.append(
        "faq",
        JSON.stringify(faq)
      );

      form.append(
        "packPricing",
        JSON.stringify(packPricing)
      );

      if (file) {

        form.append("image", file);

      }

      const response = await fetch(
        `${BACKEND_URL}/api.php?module=product`,
        {
          method: "POST",
          body: form,
        }
      );

      const result =
        await response.json();

      if (result.success) {

        alert(
          "Product Updated Successfully ✔"
        );

        navigate(
          "/admin/products/view"
        );

      } else {

        alert("Update failed");

      }

    } catch (err) {

      console.log(err);

    } finally {

      setSaving(false);

    }

  };

  return (

    <div className="add-product-page">

      <h2>Edit Product</h2>

      <form onSubmit={handleUpdate}>

        {/* PRODUCT NAME */}

        <label>Product Name</label>

        <input
          type="text"
          name="productName"
          placeholder="Product Name"
          value={formData.productName}
          onChange={handleChange}
        />

        {/* SLUG */}

        <label>Slug</label>

        <input
          type="text"
          name="slug"
          placeholder="Slug"
          value={formData.slug}
          onChange={handleChange}
        />

        {/* SKU */}

        <label>SKU</label>

        <input
          type="text"
          name="sku"
          placeholder="SKU"
          value={formData.sku}
          onChange={handleChange}
        />

        {/* DATE */}

        <label>Date</label>

        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
        />

        {/* CATEGORY */}

        <label>Category</label>

        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
        >

          {categories.map((c) => {
            const pId = c.parentId || c.parent_id;
            const parent = (pId && pId !== "0" && pId !== 0) ? categories.find((p) => String(p.id) === String(pId)) : null;
            const displayName = parent ? `${parent.categoryName} > ${c.categoryName}` : c.categoryName;
            return (
              <option
                key={c.id}
                value={c.id}
              >
                {displayName}
              </option>
            );
          })}

        </select>

        {/* SECTION */}

        <label>Section</label>

        <select
          name="section"
          value={formData.section || ""}
          onChange={handleChange}
        >
          <option value="">
            Select Section
          </option>

          <option value="bestseller">
            Bestseller
          </option>

          <option value="new-launch">
            New Launch
          </option>

          <option value="most-searched">
            Most Searched
          </option>
        </select>

        {/* PACK PRICING */}

         <h3>Pack Pricing</h3>

        {packPricing.map((item, index) => (

          <div
            key={index}
            className="pack-row"
          >

            <input
              type="number"
              placeholder="Pack Size"
              value={item.packSize}
              onChange={(e) =>
                handlePackChange(
                  index,
                  "packSize",
                  e.target.value
                )
              }
            />

            <input
              type="text"
              placeholder="Unit"
              value={item.unit}
              onChange={(e) =>
                handlePackChange(
                  index,
                  "unit",
                  e.target.value
                )
              }
            />

            <input
              type="number"
              placeholder="Price"
              value={item.price}
              onChange={(e) =>
                handlePackChange(
                  index,
                  "price",
                  e.target.value
                )
              }
            />

            <input
              type="text"
              placeholder="Unit Price"
              value={item.unitPerPrice}
              disabled
            />

            <button
              type="button"
              onClick={() =>
                removePackRow(index)
              }
            >
              Remove
            </button>

          </div>
        ))}

        <button
          type="button"
          onClick={addPackRow}
        >
          + Add Pack Size
        </button>

        {/* MANUFACTURER */}

        <label>Manufacturer</label>

        <input
          type="text"
          name="manufacturer"
          value={formData.manufacturer}
          onChange={handleChange}
        />

        {/* COMPOSITION */}

        <label>Composition</label>

        <input
          type="text"
          name="composition"
          value={formData.composition}
          onChange={handleChange}
        />

        {/* SHORT DESCRIPTION */}

        <label>Short Description</label>

        <Editor
          formData={formData}
          setFormData={setFormData}
          field="shortDescription"
        />

        {/* DESCRIPTION */}

        <label>Description</label>

        <Editor
          formData={formData}
          setFormData={setFormData}
          field="description"
        />

        {/* META TITLE */}

        <label>Meta Title</label>

        <input
          type="text"
          name="metaTitle"
          value={formData.metaTitle}
          onChange={handleChange}
        />

        {/* META DESCRIPTION */}

        <label>Meta Description</label>

        <textarea
          name="metaDescription"
          value={formData.metaDescription}
          onChange={handleChange}
        />

        {/* KEYWORDS */}

        <label>Keywords</label>

        <input
          type="text"
          placeholder="Enter keyword + Enter"
          value={keywordInput}
          onChange={(e) =>
            setKeywordInput(
              e.target.value
            )
          }
          onKeyDown={
            handleKeywordKeyDown
          }
        />

        <div className="keyword-container">
          {keywordList.map(
            (k, i) => (

              <span
                key={i}
                className="keyword-tag"
                onClick={() =>
                  removeKeyword(i)
                }
              >
                {k} ✖
              </span>

            )
          )}

        </div>

        {/* FAQ */}

        <h3>FAQ</h3>

        {faq.map((item, index) => (

          <div
            key={index}
            className="faq-box"
          >

            <label>Question</label>

            <input
              value={item.question}
              onChange={(e) => {

                const updated = [...faq];

                updated[index].question =
                  e.target.value;

                setFaq(updated);

              }}
            />

            <label>Answer</label>

            <input
              value={item.answer}
              onChange={(e) => {

                const updated = [...faq];

                updated[index].answer =
                  e.target.value;

                setFaq(updated);

              }}
            />

            <button
              type="button"
              onClick={() => {

                const updated =
                  faq.filter(
                    (_, i) => i !== index
                  );

                setFaq(updated);

              }}
            >
              ❌ Remove
            </button>

          </div>

        ))}

        <button
          type="button"
          onClick={() => {

            setFaq([
              ...faq,
              {
                question: "",
                answer: "",
              },
            ]);

          }}
        >
          ➕ Add FAQ
        </button>

        {/* IMAGE */}

        <label>Product Image</label>

        <input
          type="file"
          accept=".webp,image/webp"
          onChange={(e) => {

            const img =
              e.target.files[0];

            if (img) {

              setFile(img);

              setImagePreview(
                URL.createObjectURL(img)
              );

            }

          }}
        />

        {imagePreview && (

          <img
            src={imagePreview}
            alt=""
            width="150"
            style={{
              marginTop: "10px",
              borderRadius: "10px",
            }}
          />

        )}

        {/* SHIP TIME */}

        <label>Ship Time</label>

        <input
          type="text"
          name="shipTime"
          value={formData.shipTime}
          onChange={handleChange}
        />

        {/* STATUS */}

        <label>Status</label>

        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
        >

          <option>
            Active
          </option>

          <option>
            Inactive
          </option>

        </select>

        {/* BUTTON */}

        <button
          type="submit"
          disabled={saving}
        >

          {saving
            ? "Updating..."
            : "Update Product"}

        </button>

      </form>

    </div>

  );

}

export default EditProduct;